import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { SmallBadge } from 'components/common/Badge'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

export const CARD_WIDTH = 250
export const CARD_HEIGHT = 216

export default function GuidedCard({
  children,
  badgeLabel,
  cardIcon,
  to,
  href,
  buttonLabel,
  labelColor,
  ...props
}) {
  return (
    <div
      css={{
        height: CARD_HEIGHT,
        width: CARD_WIDTH,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        padding: theme.space[3],
        border: theme.border.base,
        borderRadius: theme.borderRadius[0]
      }}
      {...props}
    >
      <div>
        <div
          css={{ display: 'flex', justifyContent: 'space-between' }}
          data-testid="guide-card"
        >
          <SmallBadge
            css={{
              backgroundColor: labelColor,
              marginBottom: theme.space[4]
            }}
          >
            {badgeLabel}
          </SmallBadge>
          {cardIcon}
        </div>
        <Text
          as="h4"
          color="medium"
          css={{
            marginBottom: theme.space[2],
            whiteSpace: 'break-spaces'
          }}
        >
          {children}
        </Text>
      </div>

      <Button
        secondary
        as={href ? TrackedExternalLink : Link}
        css={{
          justifyContent: 'center',
          '&:focus': {
            backgroundColor: theme.colors.white[0]
          }
        }}
        href={href}
        to={to}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}

GuidedCard.propTypes = {
  children: PropTypes.string,
  badgeLabel: PropTypes.string,
  cardIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  to: PropTypes.string,
  buttonLabel: PropTypes.string,
  labelColor: PropTypes.string,
  href: PropTypes.string
}

GuidedCard.defaultProps = {
  labelColor: theme.colors.green[0],
  color: theme.colors.steel[1]
}
